// import React, { useState, useEffect } from "react";
// import { MdDateRange, MdLocationOn, MdPerson, MdChevronLeft, MdChevronRight } from "react-icons/md";
// import { FaTools } from "react-icons/fa";
// import "./EventCard.css";

// const EventCard = ({ event }) => {
//   const [current, setCurrent] = useState(0);
//   const [isFlipped, setIsFlipped] = useState(false);

//   const hasPhotos = event?.photos && event.photos.length > 0;

//   useEffect(() => {
//     if (!hasPhotos || event.photos.length <= 1) return;
    
//     const interval = setInterval(() => {
//       setCurrent(prev => (prev + 1) % event.photos.length);
//     }, 4000);
    
//     return () => clearInterval(interval);
//   }, [hasPhotos, event.photos]);

//   const nextSlide = (e) => {
//     e.stopPropagation();
//     if (hasPhotos) {
//       setCurrent(prev => (prev + 1) % event.photos.length);
//     }
//   };

//   const prevSlide = (e) => {
//     e.stopPropagation();
//     if (hasPhotos) {
//       setCurrent(prev => (prev - 1 + event.photos.length) % event.photos.length);
//     }
//   };

//   const goToSlide = (index, e) => {
//     e.stopPropagation();
//     setCurrent(index);
//   };

//   const handleCardClick = () => {
//     setIsFlipped(!isFlipped);
//   };

//   if (!event) return null;

//   return (
//     <div className="flip-card-container">
//       <div 
//         className={`flip-card ${isFlipped ? 'flipped' : ''}`}
//         onMouseEnter={() => setIsFlipped(true)}
//         onMouseLeave={() => setIsFlipped(false)}
//         onClick={handleCardClick}
//       >
//         {/* Front Side */}
//         <div className="flip-card-front">
//           {hasPhotos && (
//             <div className="carousel-container">
//               <div className="carousel-wrapper">
//                 <img
//                   src={event.photos[current]}
//                   alt={`${event.title} - ${current + 1}`}
//                   className="carousel-image"
//                 />
                

                

//               </div>
              
//               {/* Gradient Overlay with Title */}
//               <div className="gradient-overlay">
//                 <h3 className="event-title">{event.title}</h3>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Back Side */}
//         <div className="flip-card-back">
//           <div className="glassmorphism-content">
//             <h3 className="back-title">{event.title}</h3>
//             <div className="event-details">
//               <div className="detail-item">
//                 <MdDateRange className="detail-icon" />
//                 <span>{event.startDate} to {event.endDate}</span>
//               </div>
//               <div className="detail-item">
//                 <FaTools className="detail-icon" />
//                 <span>{event.type}</span>
//               </div>
//               <div className="detail-item">
//                 <MdLocationOn className="detail-icon" />
//                 <span>{event.venue}</span>
//               </div>
//               <div className="detail-item">
//                 <MdPerson className="detail-icon" />
//                 <span>{event.coordinator}</span>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EventCard;


import React, { useState, useEffect, useRef } from "react";
import {
  MdDateRange,
  MdLocationOn,
  MdPerson
} from "react-icons/md";
import { FaCalendarAlt } from "react-icons/fa";
import "./EventCard.css";

const EventCard = ({ event }) => {
  const [current, setCurrent] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [enableTransition, setEnableTransition] = useState(true);
  const intervalRef = useRef(null);

  const photos = event?.photos || [];
  const hasPhotos = photos.length > 0;
  const hasKnowMore = !!event?.pdf;

  const slides = hasPhotos ? [...photos, photos[0]] : [];

  const startAutoSlide = () => {
    if (photos.length <= 1) return;

    intervalRef.current = setInterval(() => {
      setCurrent(prev => prev + 1);
      setEnableTransition(true);
    }, 4000);
  };

  const stopAutoSlide = () => clearInterval(intervalRef.current);

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, [event]);

  // 🔁 handle seamless reset
  useEffect(() => {
    if (current === photos.length) {
      setTimeout(() => {
        setEnableTransition(false); // disable animation
        setCurrent(0);              // snap to first real slide
      }, 600); // must match CSS transition time
    }
  }, [current, photos.length]);

  if (!event) return null;

  return (
    <div
      className="event-card"
      onMouseEnter={() => {
        setIsHovered(true);
        stopAutoSlide();
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        startAutoSlide();
      }}
    >
      {/* IMAGE */}
      <div className="image-section">
        <div
          className={`slide-track ${!enableTransition ? "no-transition" : ""}`}
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {slides.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`${event.title}-${i}`}
              className="carousel-image"
            />
          ))}
        </div>
      </div>

      {/* DETAILS — ALWAYS VISIBLE */}
      <div className="event-info-section">
        <h3 className="event-title">{event.title}</h3>
        <p><MdDateRange /> {event.startDate}</p>
        <p><MdLocationOn /> {event.venue}</p>
        <p><MdPerson /> {event.coordinator}</p>
        {event.type && <p><FaCalendarAlt /> {event.type}</p>}
      </div>

      {/* HOVER OVERLAY — BUTTON ONLY */}
      {hasKnowMore && (
        <div className={`event-hover-overlay ${isHovered ? "show" : ""}`}>
          <a
            href={event.pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="know-more-btn"
          >
            Know More
          </a>
        </div>
      )}
    </div>
  );
};

export default EventCard;
